import { useState } from 'react';
import { BookOpen, ChevronDown, ChevronRight } from 'lucide-react';
import type { RagSource } from '../api/streamChat';

/**
 * Tarjeta que muestra las fuentes (documentos de la BD) que el asistente
 * consultó vía búsqueda semántica para responder. Da transparencia al usuario.
 */
export function SourcesCard({ sources }: { sources: RagSource[] }) {
  const [open, setOpen] = useState(false);

  if (sources.length === 0) return null;

  return (
    <div className="mt-3 rounded-2xl border border-slate-200 bg-slate-50/50 overflow-hidden">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-slate-100 transition"
      >
        {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        <BookOpen size={14} className="text-emerald-600" />
        <span className="text-xs font-black uppercase tracking-widest text-slate-600">
          {sources.length} documento{sources.length !== 1 ? 's' : ''} consultado{sources.length !== 1 ? 's' : ''}
        </span>
        <span className="ml-auto text-[10px] text-slate-400">
          búsqueda semántica
        </span>
      </button>

      {open && (
        <div className="border-t border-slate-200 bg-white p-3 space-y-2">
          {sources.map((s, i) => (
            <div
              key={`${s.source_table}-${s.source_id}-${i}`}
              className="rounded-lg border border-slate-200 bg-slate-50/50 px-3 py-2 text-xs"
            >
              <div className="flex items-center gap-2 mb-1">
                <span className="inline-flex items-center rounded-md bg-emerald-100 px-1.5 py-0.5 text-[10px] font-bold text-emerald-800">
                  {labelForTable(s.source_table)}
                </span>
                <span className="text-[10px] text-slate-400">id={s.source_id}</span>
                <span className="ml-auto text-[10px] font-bold text-emerald-700">
                  {Math.round(s.score * 100)}% relevancia
                </span>
              </div>
              <div className="font-bold text-slate-800 mb-1">{s.title}</div>
              <div className="text-slate-600 line-clamp-2 leading-snug">{s.snippet}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function labelForTable(t: string): string {
  switch (t) {
    case 'it_incidencias':         return 'Incidencia IT';
    case 'tareas':                  return 'Tarea';
    case 'comentarios_tarea':       return 'Comentario';
    case 'ai_message_attachments':  return 'Adjunto';
    case 'clientes':                return 'Cliente';
    case 'proveedores':             return 'Proveedor';
    default:                        return t;
  }
}
